import { useQuery } from "react-query";
import { getPlaylists, getPlaylist, } from "frontend/src/api/playlists";
import { searchPlaylists } from "frontend/src/api/playlists/search";
import { cacheKey } from "./shared";
export var useSearchPlaylists = function (params) {
    var _a = useQuery([cacheKey, params], function () {
        return searchPlaylists(params);
    }), data = _a.data, isLoading = _a.isLoading;
    return { data: data, isLoading: isLoading };
};
export var usePlaylists = function (params) {
    var _a = useQuery([cacheKey, params], function () { return getPlaylists(params); }, {
        enabled: params.type !== "private" ||
            (params.type === "private" && Boolean(params.clientId)),
    }), data = _a.data, isFetching = _a.isFetching, isLoading = _a.isLoading;
    return { data: data, isFetching: isFetching, isLoading: isLoading };
};
export var usePlaylistDetail = function (id) {
    var _a = useQuery([cacheKey, id], function () {
        return getPlaylist(id);
    }), data = _a.data, isFetching = _a.isFetching, isLoading = _a.isLoading, remove = _a.remove;
    return { playlist: data, isFetching: isFetching, isLoading: isLoading, remove: remove };
};
